/**
 * Parse a string as a strict positive integer.
 *
 * Only accepts strings that are exactly digits (e.g. "1", "42").
 * Rejects "3abc", "1.5", "", "0", and non-numeric input.
 *
 * :param s: The string to parse
 * :return: The parsed positive integer, or null if invalid
 */
export function parsePositiveInteger(s: string): number | null {
  const raw = String(s).trim()
  if (raw === '' || !/^\d+$/.test(raw)) return null
  const n = parseInt(raw, 10)
  return n >= 1 ? n : null
}
